// filepath: frontend/src/lib/websocket.ts
import { io, Socket } from 'socket.io-client';

let socket: Socket | null = null;

// VITE_WS_URL must be the Railway backend root (e.g. https://xyz.up.railway.app).
// In dev, Vite proxies '/' to localhost:4000 so no env var is needed locally.
const WS_URL = import.meta.env.VITE_WS_URL ?? '/';

export function getSocket(token: string): Socket {
  // Never recreate an existing socket — Socket.io-client handles reconnection
  // internally. The old check `|| !socket.connected` was creating duplicate
  // sockets during the brief "connecting" window, discarding room subscriptions.
  if (!socket) {
    socket = io(WS_URL, {
      auth: { token },
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: 10,
    });
  }
  return socket;
}

export function disconnectSocket(): void {
  socket?.disconnect();
  socket = null;
}

export function subscribeToShipment(shipmentId: string): void {
  socket?.emit('subscribe:shipment', shipmentId);
}

export function unsubscribeFromShipment(shipmentId: string): void {
  socket?.emit('unsubscribe:shipment', shipmentId);
}
